import React, { useEffect } from 'react';

const ShroomsPage = () => {
  useEffect(() => {
    window.location.href = '/shrooms.html';
  }, []);

  return null;
};

export default ShroomsPage;
